import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpIOService } from 'src/app/services/http-io.service';

@Component({
  selector: 'app-hr-advisory',
  templateUrl: './hr-advisory.component.html',
  styleUrls: ['./hr-advisory.component.scss']
})
export class HrAdvisoryComponent implements OnInit {
  consultationForm!: FormGroup;
  isSubmitting = false;

  constructor(private fb: FormBuilder, private io: HttpIOService, private viewportScroller: ViewportScroller) { }

  ngOnInit(): void {
    this.initForm();
  }

  public scrollToId(id: string): void {
    this.viewportScroller.scrollToAnchor(id);
  }

  private initForm(): void {
    this.consultationForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required]
    });
  }

  navigationFromCTA(): void {
    document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' });
  }


  onSubmit(): void {
    if (this.consultationForm.valid) {
      this.isSubmitting = true;
      const formData = this.consultationForm.value;

      console.log('Form Submitted:', formData);

      const message = `Name: ${this.consultationForm.value.name},
      Phone: ${this.consultationForm.value.phone}`;

      let payload = {
        path: '/helpdesk-email',
        message: message,
        email: this.consultationForm.value.email,
        subject: "HR Advisory",
      }

      this.io._helpDeskEmail(payload).subscribe(
        (res: any) => {
          console.log("Form Submitted Successfully", res)
        },
        (err: any) => {
          console.log("Form Submission Failed", err)
        }
      );

      setTimeout(() => {
        this.isSubmitting = false;
        this.consultationForm.reset();
        alert('Thank you! We have received your request and will contact you shortly.');
      }, 1500);

    } else {
      this.consultationForm.markAllAsTouched();
    }
  }
}